import React, { useEffect, useRef, useState } from 'react'
import MaterialTable from 'material-table';
import { ThemeProvider, createTheme } from '@mui/material';
import { Delete, Edit } from '@material-ui/icons';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { Select } from 'antd';
import { CircleSpinnerOverlay } from 'react-spinner-overlay';
import { getApiCall, postApiCall, postFormApiCall } from '../../utils/api';
import tableIcons from '../component/MaterialIcon';

const WorkingDay = () => {

    const defaultMaterialTheme = createTheme();
    const [selectedRow, setSelectedRow] = useState(null);
    const [loading, setLoading] = useState(false);

    const [data, setData] = useState([])

    useEffect(() => {
        fetchData()
    }, []);

    const fetchData = async () => {
        setLoading(true);

        const res = await getApiCall("workingDay/getWorkingDays")
        setData(res.data);

        res.data.forEach((data, index) => { data.serial = index + 1; });
        setLoading(false)
    }

    const columns = [
        { title: "Sl. no", field: "serial" },
        { title: "Days", field: "day_name" },
        {
            title: "Status", field: "status",
            render: (rowData) => {
                return (
                    <>
                        {rowData.is_working == 1 ? "Active" : "InActive"}
                    </>
                )
            }
        },
    ]

    return (
        <>
            <CircleSpinnerOverlay
                loading={loading}
                overlayColor="rgba(0,153,255,0.2)"
            />
            <div className='content-wrapper'>

                <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h4 className="m-0">Working Days</h4>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                    <li className="breadcrumb-item active">Working Days</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>



                <section className="content mt-4">
                    <div className="container-fluid">
                        <ThemeProvider theme={defaultMaterialTheme}>
                            <MaterialTable
                                icons={tableIcons}
                                title="Working Days"
                                columns={columns}
                                data={data}
                                onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
                                options={{
                                    exportButton: true,
                                    actionsColumnIndex: -1,
                                    headerStyle: {
                                        backgroundColor: 'rgb(0 123 255)',
                                        color: '#FFF',
                                        fontSize: 18
                                    },
                                    rowStyle: (rowData, index) => ({
                                        backgroundColor: (selectedRow === rowData.tableData.id) ? '#d3d4d1' : index % 2 !== 0 ? '#EEE' : '#FFF'
                                    }),
                                }}
                            />
                        </ThemeProvider>
                    </div>
                </section>

            </div >
        </>
    )
}

export default WorkingDay